import useWindowDimensions from "./useWindowDimensions";
import { ScreenWidth } from "../common/Enums";

export default function useMobileResolution() {
  const size = useWindowDimensions();

  return size.width < ScreenWidth.SM;
}
